module.exports = __webpack_public_path__ + "img/box6-05.2519c2c6.png";